<form [formGroup]="userForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Редактирование пользователя</h3>
  <div mat-dialog-content>
    <mat-form-field appearance="standard">
      <mat-label>Почта</mat-label>
      <input matInput formControlName="mail" placeholder="Почта"
             type="email"
             autocomplete="on"
             cdkFocusInitial
             required="required">
      <mat-error *ngIf="userForm.controls.mail.errors?.uniqueMail">занят другим пользователем</mat-error>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>Фамилия</mat-label>
      <input matInput formControlName="surname" placeholder="Фамилия"
             type="text">
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>Имя</mat-label>
      <input matInput formControlName="name" placeholder="Имя"
             type="text" required="required">
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>Отчество</mat-label>
      <input matInput formControlName="patronymic" placeholder="Отчество"
             type="text">
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>Роли</mat-label>
      <mat-select formControlName="roles" multiple>
        <mat-option *ngFor="let role of roles" [value]="role.id">{{role.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Сохранить
    </button>
  </div>
</form>
